import { render, staticRenderFns } from "./temas-registro.vue?vue&type=template&id=4af1fb86&"
import script from "./temas-registro.component.ts?vue&type=script&lang=ts&"
export * from "./temas-registro.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports